import axios from 'axios';
import store from '@/store';

// 创建axios实例
const service = axios.create({
  baseURL: window.sys.apiUrl, // api 的 base_url
  timeout: 20 * 1000 // 请求超时时间,
});

// 不需要openid的白名单接口,采用indexOf匹配
let whiteUrl = ['datasync-dataviewsimulator/services/wechatofficial/getwxUserInfo'];

// request拦截器
service.interceptors.request.use(
  async config => {
    if (whiteUrl.indexOf(config.url) == -1) {
      let openid = localStorage.getItem('openid') || (store.state.userInfo && store.state.userInfo.openid);
      if (openid) {
        config.headers['openid'] = openid;
      }
    }
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      return response;
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
